import React from "react";
import { Box, CircularProgress } from "@mui/material";
import useImagePreload from "../../../hooks/useImagePreload";

// Drop-in <img> replacement that shows a simple spinner until `src` has actually loaded, so
// switching selections (years, categories, ...) reads as "loading" instead of appearing frozen on
// the previous image while the new one downloads in the background. Only preloads the one image
// it's given — callers with a large gallery should gate loading on a single representative image
// (e.g. the first slide) rather than wrapping every item, or they'll fire a preload per item.
const LoadableImage = ({ src, alt, style, loaderSx, ...rest }) => {
  const isLoading = useImagePreload(src);

  if (isLoading) {
    return (
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          ...style,
          ...loaderSx,
        }}
      >
        <CircularProgress size={28} />
      </Box>
    );
  }

  return <img src={src} alt={alt} style={style} {...rest} />;
};

export default LoadableImage;
